import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=4b9c7a72&scoped=true"
import script from "./faq.vue?vue&type=script&lang=ts"
export * from "./faq.vue?vue&type=script&lang=ts"
import style0 from "./faq.vue?vue&type=style&index=0&id=4b9c7a72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c7a72",
  null
  
)

export default component.exports